/* SENPAI DRIP — wishlist (localStorage, no account needed) */
(function(){
  'use strict';

  var KEY = 'sd_wishlist';
  var PAGE = '/pages/wishlist';

  /* ---------- storage ---------- */
  function read(){
    try{
      var v = JSON.parse(window.localStorage.getItem(KEY));
      return Array.isArray(v) ? v.filter(function(h){ return typeof h === 'string'; }) : [];
    }catch(e){ return []; }
  }
  function write(list){
    try{ window.localStorage.setItem(KEY, JSON.stringify(list)); }
    catch(e){ /* private mode or quota — saves just won't persist */ }
    document.dispatchEvent(new CustomEvent('sd:wishlist', { detail:{ list:list } }));
  }
  function has(handle){ return read().indexOf(handle) !== -1; }

  function toggle(handle){
    var list = read();
    var i = list.indexOf(handle);
    if(i === -1){ list.unshift(handle); } else { list.splice(i, 1); }
    write(list);
    return i === -1; /* true = now saved */
  }

  /* ---------- toast ---------- */
  var toastEl, toastTimer;
  function toast(msg, withLink){
    if(!toastEl){
      toastEl = document.createElement('div');
      toastEl.className = 'sd-wish-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '';
    var span = document.createElement('span');
    span.textContent = msg;
    toastEl.appendChild(span);
    if(withLink){
      var a = document.createElement('a');
      a.href = PAGE;
      a.textContent = 'View saved';
      toastEl.appendChild(a);
    }
    toastEl.classList.add('on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function(){ toastEl.classList.remove('on'); }, 3200);
  }

  /* ---------- button state ---------- */
  function syncButtons(){
    var list = read();
    document.querySelectorAll('[data-sd-wish]').forEach(function(btn){
      var on = list.indexOf(btn.getAttribute('data-sd-wish')) !== -1;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', (on ? 'Remove from' : 'Save to') + ' wishlist');
    });
    var n = list.length;
    document.querySelectorAll('[data-sd-wish-count]').forEach(function(el){
      el.textContent = n;
      el.classList.toggle('on', n > 0);
    });
  }

  /* ---------- delegated click ---------- */
  document.addEventListener('click', function(e){
    var btn = e.target.closest ? e.target.closest('[data-sd-wish]') : null;
    if(!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var handle = btn.getAttribute('data-sd-wish');
    if(!handle) return;

    var saved = toggle(handle);
    syncButtons();

    btn.classList.remove('is-pop');
    void btn.offsetWidth;          /* restart the animation */
    if(saved) btn.classList.add('is-pop');

    toast(saved ? 'Saved for later' : 'Removed from saved', saved);

    /* on the wishlist page itself, drop the card out */
    var card = btn.closest('[data-sd-wl-card]');
    if(card && !saved){
      card.style.transition = 'opacity .3s ease, transform .35s ease';
      card.style.opacity = '0';
      card.style.transform = 'scale(.96)';
      setTimeout(function(){
        card.remove();
        var grid = document.querySelector('[data-sd-wl-grid]');
        if(grid && !grid.children.length) renderPage();
      }, 320);
    }
  });

  /* keep tabs in step */
  window.addEventListener('storage', function(e){
    if(e.key === KEY) syncButtons();
  });
  document.addEventListener('sd:wishlist', syncButtons);

  /* ---------- money ---------- */
  function money(cents, format){
    var fmt = format || '${{amount}}';
    function pad(n, d){ n = String(n); while(n.length < d) n = '0' + n; return n; }
    function commas(s){ return s.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,'); }
    var value = '';
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var name = m ? m[1] : 'amount';
    var num = (cents || 0) / 100;

    if(name === 'amount_no_decimals'){
      value = commas(String(Math.round(num)));
    } else if(name === 'amount_with_comma_separator'){
      value = commas(String(Math.floor(num))).replace(/,/g, '.') + ',' + pad(Math.round((num % 1) * 100), 2);
    } else if(name === 'amount_no_decimals_with_comma_separator'){
      value = commas(String(Math.round(num))).replace(/,/g, '.');
    } else {
      value = commas(String(Math.floor(num))) + '.' + pad(Math.round((num % 1) * 100), 2);
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ---------- wishlist page ---------- */
  function heartSVG(){
    return '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M10 16.5S3.2 12.3 3.2 7.9a3.6 3.6 0 0 1 6.8-1.7 3.6 3.6 0 0 1 6.8 1.7c0 4.4-6.8 8.6-6.8 8.6z"/></svg>';
  }

  function renderPage(){
    var wrap = document.querySelector('[data-sd-wl]');
    if(!wrap) return;

    var grid   = wrap.querySelector('[data-sd-wl-grid]');
    var empty  = wrap.querySelector('[data-sd-wl-empty]');
    var load   = wrap.querySelector('[data-sd-wl-loading]');
    var clear  = wrap.querySelector('[data-sd-wl-clear]');
    var format = wrap.getAttribute('data-money-format') || '${{amount}}';

    var list = read();

    function showEmpty(){
      if(grid) grid.innerHTML = '';
      if(load) load.hidden = true;
      if(empty) empty.hidden = false;
      if(clear) clear.hidden = true;
    }

    if(!list.length){ showEmpty(); return; }

    if(empty) empty.hidden = true;
    if(load)  load.hidden = false;
    if(clear) clear.hidden = false;

    Promise.all(list.map(function(handle){
      return fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function(r){ return r.ok ? r.json() : null; })
        .catch(function(){ return null; });
    })).then(function(products){
      if(load) load.hidden = true;

      /* drop anything that 404s — deleted or renamed products */
      var alive = [];
      var html = '';

      products.forEach(function(p, i){
        if(!p){ return; }
        alive.push(list[i]);

        var img = p.featured_image
          ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_600x$1$2')
          : '';
        var price = (p.price_varies ? 'From ' : '') + money(p.price, format);

        html +=
          '<div class="sd-card" data-sd-wl-card>' +
            '<a class="sd-card__media" href="' + p.url + '" aria-label="' + esc(p.title) + '">' +
              (img ? '<img src="' + img + '" alt="' + esc(p.title) + '" loading="lazy" width="600" height="750">' : '') +
            '</a>' +
            '<button class="sd-wish" type="button" data-sd-wish="' + esc(p.handle) + '" ' +
              'aria-pressed="true" aria-label="Remove from wishlist">' + heartSVG() + '</button>' +
            '<a class="sd-card__body" href="' + p.url + '">' +
              '<p class="sd-card__title">' + esc(p.title) + '</p>' +
              '<p class="sd-card__price">' + price + '</p>' +
            '</a>' +
          '</div>';
      });

      if(alive.length !== list.length) write(alive);
      if(!html){ showEmpty(); return; }

      if(grid) grid.innerHTML = html;
      syncButtons();
    });

    if(clear && !clear.dataset.bound){
      clear.dataset.bound = '1';
      clear.addEventListener('click', function(){
        write([]);
        syncButtons();
        showEmpty();
      });
    }
  }

  function esc(s){
    return String(s || '').replace(/[&<>"']/g, function(c){
      return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c];
    });
  }

  function init(){ syncButtons(); renderPage(); }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* theme editor re-renders sections without a page load */
  document.addEventListener('shopify:section:load', init);
})();